import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })

/* A form with pictures is sent as multipart */
const multipart = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "multipart/form-data" } })


/* CATEGORIES — every category at once, together with the groups */
export const list = data => {
    const uri = `${env.startpoint}/admin/category/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* ALL CATEGORIES */
export const all = data => {
    const uri = `${env.startpoint}/admin/category/all`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GROUPS — in the order the app shows them */
export const types = () => {
    const uri = `${env.startpoint}/admin/category/types`
    return axios.get(uri, auth()).then(response => response).catch(error => error.response)
}

/* GET */
export const get = data => {
    const uri = `${env.startpoint}/admin/category/get`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* SAVE — a new category or a change of an old one */
export const save = data => {
    const uri = `${env.startpoint}/admin/category/save`
    return axios.post(uri, data, multipart()).then(response => response).catch(error => error.response)
}

/* CHANGE STATUS */
export const status = data => {
    const uri = `${env.startpoint}/admin/category/status`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}


/* GROUP SAVE — a new group or a new name of an old one */
export const groupSave = data => {
    const uri = `${env.startpoint}/admin/category/group/save`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GROUP STATUS */
export const groupStatus = data => {
    const uri = `${env.startpoint}/admin/category/group/status`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GROUP ORDER — the whole line of ids */
export const groupOrder = data => {
    const uri = `${env.startpoint}/admin/category/group/order`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GROUP REMOVE — only an empty group */
export const groupRemove = data => {
    const uri = `${env.startpoint}/admin/category/group/remove`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
